import { render, staticRenderFns } from "./UserShopCartList.vue?vue&type=template&id=1f34b988"
import script from "./UserShopCartList.vue?vue&type=script&lang=js"
export * from "./UserShopCartList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports